import { ratingQuestionTemplate } from "./utils";
import { loc } from "../i18n/survey";

const consistencyQuestion = {
  ...ratingQuestionTemplate,
  name: 'consistency',
  title: loc("quiz.rating.title"),
  description: loc("quiz.consistency.statement"),
};

export {
  consistencyQuestion,
}
